import { ref, Ref } from "vue";
import { LotListItem } from "./useLotsData";
import { LotStatus } from "@/enums/LotStatus";

export function useLotsModals(
  selectedLotsList: Ref<LotListItem[]>,
  selectedForOptionList: Ref<LotListItem[]>,
  clearSelection: () => void,
  refreshData: () => void
) {
  const showReleaseModal = ref(false);
  const showRegDateModal = ref(false);
  const showCreateOptionModal = ref(false);
  const showTransitionModal = ref(false);
  const showCustomizeColumnsModal = ref(false);
  const attentionType = ref<"release" | "option" | "setDate" | "">("");

  const clickAction = (type: string) => {
    if (type === "option") {
      if (
        selectedLotsList.value.length ===
        selectedLotsList.value.filter(
          (item) =>
            item.status === LotStatus.AVAILABLE ||
            item.status === LotStatus.NOT_RELEASED
        ).length
      ) {
        showCreateOptionModal.value = true;
      } else {
        showTransitionModal.value = true;
        attentionType.value = type;
      }
    } else {
      showRegDateModal.value = true;
    }
  };

  const closeReleaseModal = (update: boolean) => {
    if (update) {
      refreshData();
      clearSelection();
    }

    showReleaseModal.value = false;
  };

  const closeCreateOptionModal = (update: boolean) => {
    if (update) {
      refreshData();
      clearSelection();
    }

    showCreateOptionModal.value = false;
    attentionType.value = "";
  };

  const closeRegDateModal = (update: boolean) => {
    if (update) {
      refreshData();
      clearSelection();
    }

    showRegDateModal.value = false;
  };

  const proceed = () => {
    showTransitionModal.value = false;

    switch (attentionType.value) {
      case "release":
        showReleaseModal.value = true;
        break;
      case "option":
        showCreateOptionModal.value = true;
        break;
      case "setDate":
        showRegDateModal.value = true;
        break;
    }
  };

  const onUpdateRegistrationDate = () => {
    clearSelection();
  };

  return {
    showReleaseModal,
    showRegDateModal,
    showCreateOptionModal,
    showTransitionModal,
    showCustomizeColumnsModal,
    attentionType,
    clickAction,
    closeReleaseModal,
    closeCreateOptionModal,
    closeRegDateModal,
    proceed,
    onUpdateRegistrationDate,
  };
}
